<script setup lang="ts">
import type { StickerFill } from '../SfgSticker.vue'

/**
 * SfgStarburst — 8-point zigzag burst sticker, alternating outer
 * and inner vertices around a circle. Default chalk fill with ink
 * outline; reads as a classic "NEW!" burst without any text.
 */

const props = withDefaults(defineProps<{
  border?: StickerFill
  fill?: StickerFill
  size?: number | string
  tilt?: number
}>(), {
  border: 'ink',
  fill: 'yellow',
  size: 60,
  tilt: -4,
})

const sizeCss = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
const fillVar = computed(() => `var(--color-brand-${props.fill})`)
const strokeVar = computed(() => `var(--color-brand-${props.border})`)
</script>

<template>
  <svg
    aria-hidden="true"
    :style="{
      width: sizeCss,
      height: sizeCss,
      transform: `rotate(${tilt}deg)`,
      filter: 'drop-shadow(0 3px 0 rgba(0, 0, 0, 0.6))',
    }"
    viewBox="0 0 100 100"
  >
    <!-- 8 outer + 8 inner vertices, outer radius ~45, inner ~28 -->
    <path
      d="M50 5 L61 24 L82 18 L76 39 L95 50 L76 61 L82 82 L61 76 L50 95 L39 76 L18 82 L24 61 L5 50 L24 39 L18 18 L39 24 Z"
      :fill="fillVar"
      :stroke="strokeVar"
      stroke-width="4"
      stroke-linejoin="round"
    />
  </svg>
</template>
